<template>
  <p class="ml-auto no-flex mb-0 truncate" :class="{ 'otra-tienda' : opUid !== opUidActual}">
    <v-icon>location_on</v-icon>
      {{ nombre }}
  </p>
</template>
<script>
import { OpApiService } from '@/api/OpApiService'
const opApiService = new OpApiService()
export default {
  props:['opUid'],
  data() {
    return {
      nombre: '',
      opUidActual: this.$store.getters.getOpuid
    }
  },
  created() {
    this.getNombreOp()
  },
  methods: {
    getNombreOp() {
      opApiService.getOpByUid(this.opUid)
      .then(data => {
        this.nombre = data.msopclicode + '-' + data.msopnombre 
      })
      .catch(error => {
        if (error.response.status !== 404) {
          console.log(error)
        }
        this.nombre = ''
      })
    },
  },
}
</script>

